var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 210,
    viewBox: "0 0 259 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.593 0.688275C141.593 0.688275 93.0458 -5.80203 65.1053 37.938C37.1621 81.678 9.56833 74.1176 1.06793 123.33C-6.28137 165.875 22.4854 209.23 144.133 209.23C265.78 209.23 244.914 104.706 244.914 104.706C244.914 104.706 234.169 4.07387 141.593 0.688275Z",
    fill: "#E1E6EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.654 121.467C39.9471 116.73 38.1944 110.943 37.2968 104.982C-10.2139 116.345 24.2701 199.548 24.2701 199.548L55.5926 200.747C54.5649 189.524 52.3202 178.538 44.7818 168.876C41.397 164.643 39.1372 159.846 38.5726 154.767C37.7422 144.234 39.0934 132.616 47.6993 125.254C46.2234 124.165 44.8476 122.937 43.654 121.467Z",
    fill: "#F1BB9A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.526 68.5679C108.296 74.8349 101.613 82.4638 90.5058 88.7321C89.8576 89.0993 86.5249 88.9404 85.863 89.3007C73.1569 96.2267 58.2761 101.973 41.7618 104.158C40.1968 104.364 38.7127 104.643 37.2971 104.982C38.1933 110.943 39.9474 116.731 43.6542 121.467C44.8478 122.937 46.2237 124.165 47.6996 125.254C47.8544 125.12 48.0079 124.984 48.1696 124.854C51.8573 121.748 53.6607 123.529 57.7663 125.136C61.6568 124.018 77.5353 118.994 92.5258 109.274C92.9848 108.977 94.8417 105.972 95.3035 105.664C105.17 99.0766 114.246 92.7096 123.154 80.3716C120.775 76.3927 117.861 72.5756 115.526 68.5679Z",
    fill: "#98AAB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3149 112.437C27.2828 119.774 37.7264 144.043 38.5719 154.767C39.1379 159.846 41.3963 164.643 44.7825 168.875C52.3209 178.539 54.5642 189.524 55.5919 200.747L87.4311 207.561L59.2522 124.428C59.4043 124.377 58.9096 124.165 59.4591 124.006C51.2643 110.066 40.0012 109.332 36.3149 112.437Z",
    fill: "#F6CAAB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4925 108.769C33.4925 108.769 47.6046 107.922 56.919 115.823C56.919 115.823 42.5246 120.62 36.5978 113.001C30.6696 105.382 33.4925 108.769 33.4925 108.769Z",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0453 112.187C38.0453 112.187 38.662 112.154 39.6404 112.308C43.0499 112.844 50.8418 115.654 52.0724 130.103L30.8481 120.907",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9657 26.8077C40.396 25.4787 41.1031 25.4787 41.5362 26.8077L46.623 42.467C47.056 43.7946 48.5525 44.8825 49.9489 44.8825H66.4166C67.813 44.8825 68.0323 45.5539 66.9017 46.3746L53.5804 56.0532C52.4484 56.8739 51.877 58.6331 52.31 59.9608L57.3982 75.62C57.8299 76.949 57.2584 77.3642 56.1279 76.5421L42.8051 66.8649C41.6746 66.0442 39.8246 66.0442 38.6954 66.8649L25.3727 76.5421C24.2421 77.3642 23.6707 76.949 24.1023 75.62L29.1919 59.9608C29.6222 58.6331 29.0507 56.8739 27.9216 56.0532L14.5974 46.3746C13.4683 45.5539 13.6861 44.8825 15.0839 44.8825H31.5503C32.9481 44.8825 34.4445 43.7946 34.8762 42.467L39.9657 26.8077Z",
    fill: "url(#paint0_linear_60_9498)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0013 26.8077C99.433 25.4787 100.14 25.4787 100.572 26.8077L105.66 42.467C106.093 43.7946 107.589 44.8825 108.986 44.8825H125.454C126.85 44.8825 127.068 45.5539 125.939 46.3746L112.617 56.0532C111.485 56.8739 110.914 58.6331 111.346 59.9608L116.435 75.62C116.867 76.949 116.295 77.3642 115.165 76.5421L101.842 66.8649C100.712 66.0442 98.8616 66.0442 97.731 66.8649L84.4096 76.5421C83.2791 77.3642 82.7063 76.949 83.1393 75.62L88.2288 59.9608C88.6591 58.6331 88.0877 56.8739 86.9585 56.0532L73.6344 46.3746C72.5052 45.5539 72.7231 44.8825 74.1209 44.8825H90.5873C91.985 44.8825 93.4815 43.7946 93.9131 42.467L99.0013 26.8077Z",
    fill: "url(#paint1_linear_60_9498)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.057 26.8077C167.487 25.4787 168.194 25.4787 168.627 26.8077L173.714 42.467C174.147 43.7946 175.644 44.8825 177.04 44.8825H193.508C194.904 44.8825 195.123 45.5539 193.993 46.3746L180.671 56.0532C179.539 56.8739 178.968 58.6331 179.401 59.9608L184.489 75.62C184.921 76.949 184.349 77.3642 183.219 76.5421L169.896 66.8649C168.766 66.0442 166.916 66.0442 165.786 66.8649L152.464 76.5421C151.333 77.3642 150.762 76.949 151.193 75.62L156.283 59.9608C156.713 58.6331 156.142 56.8739 155.013 56.0532L141.688 46.3746C140.559 45.5539 140.777 44.8825 142.175 44.8825H158.641C160.039 44.8825 161.536 43.7946 161.967 42.467L167.057 26.8077Z",
    fill: "url(#paint2_linear_60_9498)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.288 26.8077C225.72 25.4787 226.427 25.4787 226.859 26.8077L231.947 42.467C232.378 43.7946 233.875 44.8825 235.271 44.8825H251.74C253.137 44.8825 253.355 45.5539 252.224 46.3746L238.903 56.0532C237.771 56.8739 237.199 58.6331 237.632 59.9608L242.722 75.62C243.152 76.949 242.581 77.3642 241.45 76.5421L228.128 66.8649C226.998 66.0442 225.148 66.0442 224.018 66.8649L210.696 76.5421C209.565 77.3642 208.993 76.949 209.426 75.62L214.514 59.9608C214.946 58.6331 214.375 56.8739 213.244 56.0532L199.921 46.3746C198.791 45.5539 199.009 44.8825 200.406 44.8825H216.874C218.272 44.8825 219.768 43.7946 220.199 42.467L225.288 26.8077Z",
    fill: "url(#paint3_linear_60_9498)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.981 156.036C202.981 156.036 199.593 136.71 192.622 121.795C189.734 115.616 186.228 110.193 182.095 107.217L186.893 105.241C186.893 105.241 192.011 110.204 197.821 118.69C198.227 119.282 200.147 120.006 200.555 120.631C201.034 121.357 201.513 122.108 201.992 122.878C209.011 134.162 214.129 147.147 212.06 161.633C206.989 197.115 202.981 156.036 202.981 156.036Z",
    fill: "#98AAB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.476 17.1331C153.908 15.8041 154.615 15.8041 155.047 17.1331L169.338 61.1115C169.77 62.4392 171.265 63.5257 172.663 63.5257H218.913C220.311 63.5257 220.529 64.1985 219.397 65.0192L181.981 92.1984C180.852 93.0205 180.281 94.7784 180.711 96.1074L195.004 140.084C195.434 141.413 194.863 141.829 193.734 141.008L156.316 113.827C155.187 113.007 153.337 113.007 152.206 113.827L114.791 141.008C113.659 141.829 113.087 141.413 113.52 140.084L127.811 96.1074C128.244 94.7784 127.672 93.0205 126.542 92.1984L89.1251 65.0192C87.9959 64.1985 88.2138 63.5257 89.6115 63.5257H135.86C137.257 63.5257 138.753 62.4392 139.185 61.1115L153.476 17.1331Z",
    fill: "#FDD058"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.311 127.163C186.231 127.31 184.315 127.641 182.94 128.099C182.812 128.141 182.691 128.2 182.573 128.266C183.472 128.909 184.257 129.661 184.936 130.497C186.006 131.816 186.797 133.348 187.304 134.986C188.752 132.826 188.982 129.968 188.311 127.163Z",
    fill: "#395C6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.3 150.695C209.482 149.665 208.555 148.565 207.603 147.265C206.483 145.736 205.331 143.927 204.284 141.625C203.377 139.628 201.235 137.8 200.581 134.918C200.355 133.922 200.502 132.749 199.97 131.744C197.76 127.558 193.924 126.767 188.311 127.163C188.982 129.968 188.752 132.826 187.304 134.987C187.439 135.428 187.558 135.877 187.654 136.334C187.944 137.731 188.038 139.186 187.927 140.641C187.79 142.413 187.353 144.185 186.603 145.855C186.516 146.051 184.308 148.269 184.211 148.463C183.647 149.875 185.815 149.983 184.405 151.112C184.107 151.409 182.713 151.781 182.424 151.663C186.565 156.121 192.534 157.321 198.182 158.575C197.899 159.423 199.594 158.012 199.594 158.012C205.147 159.623 210.507 176.099 213.141 158.293C213.469 155.062 212.173 153.059 210.3 150.695Z",
    fill: "#E7824F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.328 146.441C189.479 140.14 188.046 132.178 182.574 128.266C177.167 130.256 177.604 143.608 182.706 147.806C184.117 148.651 185.763 147.852 186.328 146.441Z",
    fill: "#F0AF88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.542 167.465C180.303 167.44 180.066 167.407 179.83 167.367L174.217 211.369C174.217 211.369 179.112 205.857 184.377 205.868C184.207 196.388 183.992 181.092 182.517 171.415C182.235 170.287 182.799 167.465 180.542 167.465Z",
    fill: "#F7D5BE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.42 162.103C191.69 160.291 192.025 157.663 191.131 155.567C186.445 154.054 182.329 152.156 180.68 150.378C173.717 147.331 169.43 142.702 166.806 137.91C166.191 136.789 164.9 135.852 164.454 134.73C161.174 126.465 162.902 118.505 162.902 118.505H156.41C155.048 126.251 156.013 131.17 156.834 136.705C157.008 137.885 156.21 140.653 156.46 141.742C161.36 163.087 179.835 167.324 179.835 167.324L179.83 167.367C180.066 167.407 180.303 167.441 180.542 167.465C180.574 167.465 180.604 167.467 180.634 167.469C181.356 167.339 182.079 167.158 182.799 166.9C185.622 165.771 188.728 164.926 190.42 162.103Z",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.8 166.901C182.079 167.158 181.356 167.339 180.635 167.469C182.781 167.547 182.24 170.303 182.518 171.415C183.991 181.091 183.784 196.811 183.954 206.291C185.82 206.293 187.901 206.182 190.096 205.985C188.65 192.41 187.21 178.894 186.673 165.318C185.43 165.929 184.085 166.387 182.8 166.901Z",
    fill: "#FBE7AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.454 157.284C195.342 156.814 193.182 156.227 191.131 155.566C192.025 157.662 191.69 160.29 190.42 162.104C189.499 163.64 188.157 164.588 186.673 165.318C187.209 178.894 188.649 192.41 190.096 205.985C192.817 205.741 195.718 205.364 198.63 204.912C197.954 189.037 198.394 173.16 197.454 157.284Z",
    fill: "#F7D5BE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.089 158.257C201.339 158.057 199.418 157.721 197.454 157.284C198.393 173.16 197.955 189.036 198.63 204.911C200.898 204.559 203.174 204.159 205.372 203.74C204.534 190.52 204.531 177.299 203.687 164.079C203.576 162.107 203.34 160.177 203.089 158.257Z",
    fill: "#FBE7AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.754 158.012C208.353 158.553 205.947 158.584 203.09 158.257C203.339 160.178 203.576 162.107 203.686 164.079C204.53 177.299 204.533 190.519 205.373 203.74C209.984 202.857 214.257 201.886 217.446 201.061C215.313 189.201 214.353 177.395 213.814 165.545C212.633 163.125 211.293 160.615 209.754 158.012Z",
    fill: "#F7D5BE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.02 199.212C222.051 191.461 220.964 180.2 213.814 165.545C214.354 177.395 215.313 189.2 217.447 201.062C220.878 200.174 223.05 199.457 223.02 199.212Z",
    fill: "#FBE7AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8868 75.4694C49.9368 74.7241 51.8663 73.9815 53.9123 73.3169C47.1015 68.2132 33.021 62.7519 26.2308 75.0515C33.4499 76.1517 40.6677 77.8754 47.8868 75.4694Z",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0254 98.6097C25.8723 99.4564 28.6953 94.376 30.9523 97.4807C31.5169 98.6097 31.2346 99.7387 31.2346 100.866C34.0575 99.7387 37.1614 99.7387 38.5729 102.278C39.1375 103.124 38.8552 104.535 38.8552 105.664C41.3369 105.016 43.6556 105.155 45.8866 105.696C46.2305 104.912 46.606 104.131 46.9664 103.346C45.2973 101.964 43.6282 100.842 41.9591 99.1742C35.6321 93.2305 27.7401 91.5878 19.6152 91.3206C19.0917 93.0387 18.6052 94.7774 18.153 96.5271C20.7334 96.2407 23.185 96.5065 25.0254 98.6097Z",
    fill: "#98AAB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1301 106.793C29.8226 107.64 30.1048 109.616 29.8226 111.308C30.9531 111.308 31.2354 109.898 32.0823 109.616C34.3393 109.05 36.5977 110.462 36.5977 113.001H39.2713C39.8674 111.187 41.3501 109.432 44.7815 109.05C44.9898 107.904 45.405 106.796 45.886 105.697C43.6551 105.154 41.3378 105.017 38.8547 105.664C38.8547 104.536 39.137 103.124 38.5724 102.278C37.1623 99.7383 34.057 99.7383 31.2354 100.867C31.2354 99.7383 31.5177 98.6093 30.9531 97.4803C28.6947 94.3756 25.8731 99.456 25.0249 98.6093C23.1858 96.5075 20.7343 96.2403 18.1538 96.528C17.3467 99.6437 16.6464 102.795 16.0394 105.923C17.9223 106.477 19.7147 107.363 21.3564 108.769C22.7679 106.793 25.5895 105.664 28.1301 106.793Z",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7677 116.952C22.4854 116.387 23.05 115.258 23.05 115.258C25.0247 113.565 28.4123 113.284 30.1047 115.541V116.67C33.0113 115.632 35.9151 115.206 38.9313 114.828C38.9696 114.246 39.0683 113.621 39.2711 113.002H36.5975C36.5975 110.462 34.3391 109.05 32.0821 109.615C31.2353 109.897 30.953 111.308 29.8224 111.308C30.1047 109.615 29.8224 107.639 28.13 106.792C25.5907 105.665 22.7677 106.792 21.3563 108.768C19.7145 107.362 17.9221 106.476 16.0392 105.922C15.4376 109.016 14.9265 112.087 14.4921 115.08C15.6747 115.353 16.7778 115.809 17.6878 116.387C19.3802 117.799 20.7917 116.952 22.7677 116.952Z",
    fill: "#98AAB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9313 114.828C35.9151 115.206 33.0113 115.632 30.1061 116.669V115.542C28.4123 113.284 25.0261 113.566 23.05 115.258C23.05 115.258 22.4855 116.388 22.7677 116.951C20.7917 116.951 19.3802 117.798 17.6878 116.388C16.7779 115.809 15.6747 115.354 14.4921 115.081C13.996 118.504 13.6 121.824 13.2834 124.961C15.6802 125.701 18.4141 125.187 20.7917 123.725C21.074 123.725 22.2032 123.161 21.9209 122.314C22.7677 126.264 28.9769 126.264 31.7999 125.418C32.004 125.33 32.2178 125.26 32.433 125.198L49.0158 128.24C49.0158 128.24 38.8326 116.321 38.9313 114.828Z",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7997 125.418C28.9768 126.264 22.7676 126.264 21.9207 122.314C22.203 123.161 21.0738 123.726 20.7915 123.726C18.4139 125.187 15.6801 125.701 13.2833 124.961C13.0476 127.295 12.8585 129.524 12.7022 131.619C14.0754 131.593 15.4005 131.554 16.5585 131.626V130.78C18.4071 133.244 20.9286 134.53 23.7104 135.191L32.4328 125.198C32.2177 125.26 32.0039 125.33 31.7997 125.418Z",
    fill: "#98AAB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.308 138.052C12.0421 141.222 8.71625 147.865 9.50148 148.557C9.50148 148.557 18.5336 146.018 21.1633 138.109C18.4048 137.984 15.2913 138.279 12.308 138.052Z",
    fill: "#98AAB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5583 130.78V131.626C15.4004 131.554 14.0752 131.592 12.7035 131.62C12.5308 133.949 12.4034 136.108 12.3074 138.052C15.2907 138.278 18.4056 137.984 21.1628 138.108L23.7103 135.191C20.9284 134.53 18.407 133.244 16.5583 130.78Z",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4357 80.804C21.9845 84.1485 20.7196 87.6862 19.6151 91.3198C27.7414 91.5869 35.632 93.2311 41.9603 99.1734C43.6281 100.842 45.2972 101.963 46.9663 103.345C47.6282 101.901 48.2312 100.438 48.4518 98.8911C48.7341 97.7621 49.0164 96.07 49.581 94.6588C49.6714 94.3875 49.7605 94.1135 49.8468 93.8408C45.785 84.9637 32.8625 80.4711 23.4357 80.804Z",
    fill: "#BBC7D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.913 73.3172C51.867 73.9804 49.9375 74.7243 47.8875 75.4697C40.6684 77.8756 33.4492 76.1506 26.2315 75.0518C26.2055 75.0984 26.1794 75.1409 26.1548 75.1874C25.1818 76.9809 24.2774 78.8608 23.4359 80.8036C32.8627 80.472 45.7839 84.9633 49.8471 93.8404C51.8095 87.7173 53.0757 81.3325 57.4828 76.8809C56.9429 75.9232 55.6684 74.6312 53.913 73.3172Z",
    fill: "#98AAB6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.656 76.4274C57.593 75.9794 56.7118 75.9013 56.0732 75.4697C51.4661 80.1199 47.1878 84.0577 45.0651 90.426C44.4991 91.8373 44.2182 93.5294 43.9359 94.6584C43.4261 98.2221 45.1253 105.576 44.4991 109.05C45.0637 108.986 47.5153 109.332 48.1689 109.332C48.1689 109.332 60.1967 94.4871 57.656 76.4274Z",
    fill: "#E98C5C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.635 126.973C118.606 136.43 106.279 140.199 94.7422 140.703C92.2413 140.814 91.5095 137.16 89.0949 136.989C62.4152 135.084 39.8849 121.098 39.8849 121.098C39.8849 121.098 33.525 117.918 25.9715 128.251C18.4181 138.586 29.2591 147.429 29.2591 147.429C52.6636 159.105 72.6203 162.95 89.0949 160.127C90.257 159.929 91.4273 157.879 92.5537 157.632C113.057 153.167 127.772 141.292 136.511 132.19C137.076 130.215 134.819 126.547 130.635 126.973Z",
    fill: "#395C6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.012 111.026C151.189 110.744 147.238 115.823 147.238 115.823L143.016 118.726C142.805 118.757 142.296 118.875 141.24 119.162C139.935 117.533 143.451 110.49 139.898 110.744C138.187 110.865 132.843 125.982 132.843 125.982L132.86 126.008C132.615 126.833 132.561 127.393 132.561 127.393L129.456 129.651C130.41 132.544 132.26 133.844 134.818 133.884L139.898 128.24C139.898 128.24 156.835 111.308 154.012 111.026Z",
    fill: "#E98C5C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.19 63.8995L123.246 57.4092C123.246 57.4092 124.657 59.1027 122.399 61.077C122.399 61.077 122.217 60.5906 125.554 59.141C128.892 57.6914 133.407 63.335 133.407 63.335C133.407 63.335 127.761 71.5188 122.117 71.2365C116.472 70.9543 120.989 63.335 120.989 63.335L116.19 63.8995Z",
    fill: "#E98C5C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.137 121.656L165.465 119.13L166.224 107.974C166.224 107.974 161.159 108.45 160.198 112.282L159.238 116.114C159.238 116.114 156.567 116.317 155.916 118.335C155.264 120.355 158.137 121.656 158.137 121.656Z",
    fill: "#F0AF88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_60_9498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 210
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.132 22.1675C36.63 20.052 35.7187 37.4691 31.9721 40.7917C30.6963 41.9234 26.0973 41.8974 21.3819 41.8714C16.1183 41.8412 10.7108 41.8124 9.62411 43.3922C7.56033 46.3928 27.1731 57.5785 25.6218 61.108C20.2623 73.3035 7.19993 84.7729 4.59074 101.342C3.47115 108.449 2.36663 115.817 1.06752 123.33C0.374111 127.35 0.00137037 131.379 0 135.376V135.429C0.0150741 173.716 34.0304 209.23 144.133 209.23C265.779 209.23 244.915 104.706 244.915 104.706C244.915 104.706 243.785 94.1185 239.098 79.6965C238.939 79.2115 245.407 79.5266 245.407 79.5266L242.691 57.3771L258.819 43.4922L236.608 42.2344L225.57 19.0491C225.57 19.0491 218.49 39.4408 217.45 38.1213C202.039 18.5915 178.221 2.02798 141.594 0.687998C141.594 0.687998 139.047 0.348206 134.792 0.348206C120.451 0.348206 86.6526 4.20649 65.1049 37.9377C61.1185 44.1773 52.6291 26.2039 42.132 22.1675Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_60_9498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.892 105.241L179.884 94.095C179.884 94.095 176.308 96.6338 177.156 100.303L178.003 103.971C178.003 103.971 174.615 103.406 174.615 104.535C174.615 105.664 185.34 109.332 185.34 109.332L186.892 105.241Z",
    fill: "#F0AF88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_9498",
    x1: 13.8747,
    y1: 25.811,
    x2: 13.8747,
    y2: 76.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_9498",
    x1: 72.9117,
    y1: 25.811,
    x2: 72.9117,
    y2: 76.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60_9498",
    x1: 140.966,
    y1: 25.811,
    x2: 140.966,
    y2: 76.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60_9498",
    x1: 199.197,
    y1: 25.811,
    x2: 199.197,
    y2: 76.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star-rating.b200ce55.svg";
export { ForwardRef as ReactComponent };